import { useEffect, useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, formatDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

const Row = ({ title, desc, checked, onChange, testid }) => (
  <label className="flex items-start justify-between gap-4 py-3 border-t first:border-t-0 cursor-pointer">
    <span><span className="block text-sm font-medium text-slate-900">{title}</span><span className="block text-xs text-slate-500">{desc}</span></span>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} />
  </label>
);

// Area riservata: il cliente modifica o revoca i consensi facoltativi.
export const ClientPrivacyConsents = () => {
  const [d, setD] = useState(null);
  const [v, setV] = useState({ marketing: false, terzi: false });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/client/gdpr-consents").then(({ data }) => { setD(data); setV({ marketing: data.marketing, terzi: data.terzi }); }).catch(() => setD(false));
  }, []);

  if (d === false) return null;
  const dirty = d && (v.marketing !== d.marketing || v.terzi !== d.terzi);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/client/gdpr-consents", v);
      if (data.consents) setD({ ...d, ...data.consents });
      toast.success("Preferenze privacy aggiornate");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <section className="mt-10 bg-white border border-slate-200 rounded-lg p-4 sm:p-5" id="client-privacy-section" data-testid="client-privacy-section">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-emerald-600" /> Privacy e consensi</h2>
      {!d ? <Loader2 className="h-5 w-5 animate-spin text-slate-400 mt-3" /> : (
        <>
          <p className="text-xs text-slate-500 mt-1">Il trattamento dei dati per gestire le tue polizze è necessario. Questi consensi sono facoltativi e puoi cambiarli quando vuoi.</p>
          <div className="mt-2">
            <Row title="Comunicazioni commerciali" desc="Offerte, promozioni e novità dall'agenzia" checked={v.marketing} onChange={(x) => setV({ ...v, marketing: x })} testid="client-privacy-marketing" />
            <Row title="Cessione a terzi" desc="Comunicazione dei dati a partner per loro offerte" checked={v.terzi} onChange={(x) => setV({ ...v, terzi: x })} testid="client-privacy-terzi" />
          </div>
          <div className="flex flex-wrap items-center justify-between gap-2 mt-3">
            <span className="text-[11px] text-slate-500" data-testid="client-privacy-last">{d.at ? `Ultimo aggiornamento: ${formatDate(d.at)}` : "Nessuna preferenza registrata"}</span>
            <Button size="sm" onClick={save} disabled={!dirty || saving} data-testid="client-privacy-save">{saving && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Salva preferenze</Button>
          </div>
        </>
      )}
    </section>
  );
};
